import React from 'react';
import classNames from 'classnames';
import { BACKGROUND_COLOR } from '@jwp/ott-web/src/config/clientEnvConfig';

import Spinner from '../Spinner/Spinner';

import styles from './LoadingOverlay.module.scss';

type Props = {
  transparentBackground?: boolean;
  inline?: boolean;
  profileImageUrl?: string;
};

const LoadingOverlay = ({ transparentBackground = false, inline = false, profileImageUrl = '' }: Props): JSX.Element => {
  const className = classNames(styles.loadingOverlay, {
    [styles.transparent]: transparentBackground,
    [styles.fixed]: !inline,
    [styles.inline]: inline,
    [styles.profile]: profileImageUrl,
  });

  const inlineStyle = !inline && !transparentBackground ? { backgroundColor: BACKGROUND_COLOR } : undefined;

  return (
    <div className={className} style={inlineStyle}>
      {profileImageUrl && <img src={profileImageUrl} alt="Profile Avatar" />}
      <Spinner size={profileImageUrl ? 'large' : 'medium'} />
    </div>
  );
};
export default LoadingOverlay;
